import { Controller } from "@hotwired/stimulus"

// This controller is used to update the screen with the number of selected leads.
export default class extends Controller {
  static get targets() {
    return ["selected", "selectedCount", "total"]
  }

  static get values() {
    return { selected: Number }
  }

  // This action updates the screen.
  // We trigger this using the check-all controller.
  update(event) {
    this.selectedValue = event.detail.checked

    if (this.selectedValue > 0) {
      this.selectedCountTarget.innerText = i18n.t("js.back.lead_actions.count_selected_leads", { count: this.selectedValue, leads_count: i18n.numberToDelimited(this.selectedValue, { separator: i18n.translations[i18n.locale].js.number.format.separator, delimiter: i18n.translations[i18n.locale].js.number.format.delimiter}) })
      this.selectedTarget.classList.remove("d-none")
      this.totalTarget.classList.add("d-none")
    } else {
      this.selectedTarget.classList.add("d-none")
      this.totalTarget.classList.remove("d-none")
    }
  }
}
